/*!
  Dripplug, Design by Visuno Production
  theme-mode.css
  https://visuno.ch
*/

document.addEventListener("DOMContentLoaded", function() {
  enable_dark_mode();
});
document.addEventListener("shopify:section:load", function() {
  enable_dark_mode();
});
document.addEventListener("shopify:section:unload", function() {
  enable_dark_mode();
});
document.addEventListener("shopify:section:reorder", function() {
  enable_dark_mode();
});
function enable_dark_mode() {
  //DOM refs
  var bravaMode = document.getElementsByTagName("BODY")[0];
  var themeStyleBtns = document.querySelectorAll(".light-mode");
  var themeLabel = document.querySelector(".theme-mode-label .mode-button-text");
  var themeIcons = document.querySelector(".theme-mode-icons");
  //set to show in theme editor
  var defaultText = document.querySelector('.mode-button-text')
  defaultText.classList.add('d-none');
  themeIcons.classList.remove('d-none');
  themeIcons.classList.add('d-block');

  if (themeStyleBtns.length > 0) {
    //set the state - default to dark mode if not set
    if (!localStorage.lightMode) {
      localStorage.lightMode = "dark";
    }
    if (localStorage.lightMode == "dark") {
      bravaMode.setAttribute("light-mode", "dark");
      themeLabel.innerHTML = `${window.theme.darkMode}`;
    } else {
      bravaMode.setAttribute("light-mode", "light");
    }
    //change the state
    themeStyleBtns.forEach(function(themeStyle) {
      themeStyle.addEventListener('click', function() {
        toggleMode();
      });
    });
    //toggle functionality
    function toggleMode() {
      var bravaMode = document.getElementsByTagName("BODY")[0];
      if (localStorage.lightMode == "dark") {
        localStorage.lightMode = "light";
        bravaMode.setAttribute("light-mode", "light");
        themeLabel.innerHTML = `${window.theme.lightMode}`;
      } else {
        localStorage.lightMode = "dark";
        bravaMode.setAttribute("light-mode", "dark");
        themeLabel.innerHTML = `${window.theme.darkMode}`;
      }
    }
    window.addEventListener("storage", function() {
      if (!localStorage.lightMode) {
        localStorage.lightMode = "dark";
      }
      if (localStorage.lightMode == "dark") {
        bravaMode.setAttribute("light-mode", "dark");
        themeLabel.innerHTML = `${window.theme.darkMode}`;
      } else {
        bravaMode.setAttribute("light-mode", "light");
        themeLabel.innerHTML = `${window.theme.lightMode}`;
      }
    }, false);
  }
}
